module.exports = __webpack_public_path__ + "img/banner.e7c692d.jpg";